import { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";
import client_one from "../../common/images/italian.png";
import client_two from "../../common/images/aygo.png";
import client_three from "../../common/images/aps.png";
import client_four from "../../common/images/al-nayel.png";
import client_five from "../../common/images/chikitos.png";
import client_six from "../../common/images/pos.png";
import client_seven from "../../common/images/mjc.png";
import client_eight from "../../common/images/compare.png";

const clientLogos = [
  client_one,
  client_three,
  client_four,
  client_five,
  client_six,
  client_seven,
  client_eight,
  client_two,

];

const ClientCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visibleSlides, setVisibleSlides] = useState(5); // Default for large screens

  useEffect(() => {
    const updateSlides = () => {
      setVisibleSlides(window.innerWidth < 640 ? 2 : 5); // 2 slides for mobile, 5 for larger screens
    };
    updateSlides();
    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + 1 < clientLogos.length - (visibleSlides - 1) ? prevIndex + 1 : prevIndex
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  return (
    <div className="bg-blue-100 pt-5">
      <h3 className="text-secondary text-center small:text-3xl text-2xl font-semibold">
        Our Clients
        <div className="underline py-3 w-fit mx-auto">
          <img
            alt="underline"
            src={require("../../common/images/blue-underline.png")}
            className="w-[78px] h-[5px]"
          />
        </div>
      </h3>

      <div className="max-w-[1290px] mx-auto overflow-hidden">
        <div className="relative max-w-[1280px] mx-auto px-4">
          <div
            className="flex transition-transform duration-300"
            style={{ transform: `translateX(-${currentIndex * (100 / visibleSlides)}%)` }}
          >
            {clientLogos.map((logo, index) => (
              <div key={index} className="w-1/2 small:w-1/5 flex-shrink-0 p-4">
                <img
                  src={logo}
                  alt={`Client Logo ${index + 1}`}
                  className="small:h-32 h-28 w-full object-contain transition-all hover:scale-110"
                />
              </div>
            ))}
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute md:-left-1 left-0 top-1/2  -translate-y-1/2 z-10 p-3 rounded-full bg-[#BDD2FB] shadow-lg"
          >
            <FaChevronLeft className="text-gray-800 text-xl font-medium" />
          </button>
          <button
            onClick={nextSlide}
            className="absolute md:-right-1 right-0 top-1/2  -translate-y-1/2 z-10 p-3 rounded-full bg-[#BDD2FB] shadow-lg"
          >
            <FaChevronRight className="text-gray-800 text-xl font-medium" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientCarousel;
